import React from 'react';
import { FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import './ErrorModal.css';

const FeedbackModal = ({ isOpen, onClose, title, message, type = 'error' }) => {
    if (!isOpen) return null;

    const isSuccess = type === 'success';

    return (
        <div className="error-modal-overlay" onClick={onClose}>
            <div className="error-modal-content" onClick={e => e.stopPropagation()}>
                <div className="error-modal-header">
                    {isSuccess ? (
                        <FaCheckCircle className="error-icon success" />
                    ) : (
                        <FaExclamationCircle className="error-icon" />
                    )}
                    <h3>{title || (isSuccess ? 'Éxito' : 'Error')}</h3>
                </div>
                <div className="error-modal-body">
                    <p>{message}</p>
                </div>
                <div className="error-modal-footer">
                    <button className={`error-close-btn ${isSuccess ? 'success' : ''}`} onClick={onClose}>
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
